import React from 'react';

const Pay = () => {
    return (
        <div>
            <img  className='d-block mx-auto' src="../../../../Images/coming-soon.png" alt=""/>
       
        </div>
    );
};

export default Pay;